import InstructorSearch from "./InstructorSearch";
export default InstructorSearch;
